<div class="notification-resume-wrapper" *ngIf="currentNotification">
  <app-notification [isPrimaryCta]="currentNotification?.isPrimaryCta ?? false" [outline]="true" class="margin-bottom" [buttonMessage]="currentNotification.ctaLabel"
                    (onButtonClick)="currentNotification.ctaAction()" color="#8C5FB0" [icon]="currentNotification.icon"
                    [title]="currentNotification.title">
    <p *ngFor="let message of currentNotification.content.split('\n')">{{message}}</p>
  </app-notification>
</div>
